import { DeleteKeyValueRequest } from "@models/base/deleteKeyValueRequest.model";

export class DeleteExpedienteRequest extends DeleteKeyValueRequest{
}
  